/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fluffy_Just_Anteater_WishInputs */

const fr_fluffy_just_anteater_wish = /** @type {(inputs: Fluffy_Just_Anteater_WishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack modifiés avec succès`)
};

/**

* @param {Fluffy_Just_Anteater_WishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fluffy_just_anteater_wish = /** @type {((inputs?: Fluffy_Just_Anteater_WishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fluffy_Just_Anteater_WishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fluffy_just_anteater_wish(inputs)
});